import { CookiePolicy } from './CookiesPolicy';

export default props => new CookiePolicy({
	...props,
});



// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/components/CookiesPolicy4/index.js